import React from 'react';
import Data from './Data';

const ThumbnailsSidebar = (props) => {
  return <Data {...props} />;
};

export default ThumbnailsSidebar;
